export enum QuestionType {
  radio = 0,
  select = 1,
  text_box = 2,
  text_area = 3,
  checkbox = 4,
}
